module.exports = __webpack_public_path__ + "img/inst.e90afcfd.svg";